module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('row', {
    staticClass: "loginForm"
  }, [_c('column', {
    staticClass: "col-md-8"
  }, [_c('va-box', {
    attrs: {
      "title": "Account Info",
      "theme": "box-info",
      "isBorder": true,
      "widgetType": ""
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v("Account Name")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.account.fullname),
      expression: "account.fullname"
    }],
    staticClass: "form-control",
    staticStyle: {
      "cursor": "text"
    },
    attrs: {
      "type": "text",
      "placeholder": "Full Name",
      "readonly": "",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.account.fullname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.account, "fullname", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v("Email")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.account.username),
      expression: "account.username"
    }],
    staticClass: "form-control",
    staticStyle: {
      "cursor": "text"
    },
    attrs: {
      "type": "email",
      "placeholder": "Email",
      "readonly": "",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.account.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.account, "username", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v("Auth Key")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$root.user.AuthKey),
      expression: "$root.user.AuthKey"
    }],
    staticClass: "form-control",
    staticStyle: {
      "cursor": "text"
    },
    attrs: {
      "type": "email",
      "placeholder": "Auth Key",
      "readonly": "",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.$root.user.AuthKey)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.$root.user, "AuthKey", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('va-alert', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.error),
      expression: "error"
    }],
    attrs: {
      "type": _vm.alertType,
      "dismissible": true
    }
  }, [_c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [(_vm.alertType === 'success') ? _c('i', {
    staticClass: "icon fa fa-check"
  }) : _c('i', {
    staticClass: "icon fa fa-ban"
  }), _vm._v(" " + _vm._s(_vm.error) + "\n              ")])])], 1)]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10",
    staticStyle: {
      "text-align": "right",
      "cursor": "pointer"
    }
  }, [_c('a', {
    staticClass: "control-label",
    on: {
      "click": function($event) {
        return _vm.sendResetPassword()
      }
    }
  }, [_vm._v("Reset Password")])])])])])], 1), _vm._v(" "), _c('column', {
    staticClass: "col-md-4"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "#",
      "data-toggle": "dropdown"
    }
  }, [_c('img', {
    staticClass: "user-image roundImage",
    staticStyle: {
      "width": "160px"
    },
    attrs: {
      "src": _vm.logoPath,
      "alt": "User Image"
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', {
    staticStyle: {
      "margin": "0px",
      "border": "none"
    },
    attrs: {
      "action": "#",
      "method": "get"
    }
  }, [_c('div', {
    staticClass: "input-group btnUpload",
    staticStyle: {
      "padding": "5px 10px",
      "width": "160px",
      "text-align": "center",
      "color": "green"
    }
  }, [_c('span', {
    staticClass: "btnUpload"
  }, [_vm._v("Upload Logo")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file"
    },
    on: {
      "change": _vm.uploadLogo
    }
  })])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2654b7d4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Account.vue
// module id = 683
// module chunks = 0